module.exports = __webpack_public_path__ + "static/img/empty-icon.33c78254.png";